// plugins/branding.client.ts
import { getBackendClient, unwrapApiResponse, type ApiSchema } from '~/api/client'

const DEFAULT_FAVICON_URL = '/public/favicon.ico'
const DEFAULT_FAVICON_TYPE = 'image/x-icon'

function setFavicon(href: string, type: string) {
  let link: HTMLLinkElement | null
    = document.querySelector('link[rel~=\'icon\']')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = href
  link.type = type
}

async function loadBrandingFavicon() {
  const apiClient = getBackendClient({ auth: false })

  try {
    const branding: ApiSchema<'GetBranding'> = await unwrapApiResponse(
      apiClient.GET('/branding'),
    )

    if (branding.favicon_url) {
      let type = 'image/x-icon' // Default type if we can't infer
      if (branding.favicon_url.endsWith('.ico')) {
        type = 'image/x-icon'
      }
      else if (branding.favicon_url.endsWith('.png')) {
        type = 'image/png'
      }
      else if (branding.favicon_url.endsWith('.svg')) {
        type = 'image/svg+xml'
      }
      setFavicon(branding.favicon_url, type)
    }
    else {
      $logError(
        'Branding data received, but no faviconUrl provided. Using default.',
      )
      setFavicon(DEFAULT_FAVICON_URL, DEFAULT_FAVICON_TYPE)
    }
  }
  catch (error) {
    $logError(
      'Failed to load branding and set favicon. Using default favicon.',
      error,
    )
    setFavicon(DEFAULT_FAVICON_URL, DEFAULT_FAVICON_TYPE)
  }
}

export default defineNuxtPlugin(() => {
  setFavicon(DEFAULT_FAVICON_URL, DEFAULT_FAVICON_TYPE)
  void loadBrandingFavicon()
})
